import { render } from "./TeamJerseyBadge.vue?vue&type=template&id=191b65a3&scoped=true"
import script from "./TeamJerseyBadge.vue?vue&type=script&lang=js"
export * from "./TeamJerseyBadge.vue?vue&type=script&lang=js"

import "./TeamJerseyBadge.vue?vue&type=style&index=0&id=191b65a3&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191b65a3"]])

export default __exports__